import React from 'react';
import { Heading, Flex, Text, Tag } from '@applyboard/crystal-ui';
import { TuitionHifiIcon } from '@applyboard/ui-icons';
import { useScholarshipPageContext } from "../../contexts";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ScholarshipTitleHeader = function ScholarshipTitleHeader() {
  var _useScholarshipPageCo = useScholarshipPageContext(),
    scholarship = _useScholarshipPageCo.scholarship;
  var showSchoolGroupName = !!scholarship.schoolGroupName;
  var showScholarshipStatus = !!scholarship.status;
  var statusIntent = scholarship.status === 'active' ? 'positive' : 'secondary';
  return _jsxs(Flex, {
    direction: "row",
    gap: 4,
    align: "center",
    children: [_jsx(Flex.Item, {
      children: _jsx(TuitionHifiIcon, {
        contrast: "mid",
        intent: "secondary"
      })
    }), _jsxs(Flex, {
      direction: "column",
      gap: 0,
      children: [_jsxs(Flex, {
        direction: "row",
        gap: 2,
        align: {
          xs: 'start',
          md: 'center'
        },
        children: [_jsx(Heading, {
          level: 1,
          variant: "titleL",
          lineClamp: 3,
          children: scholarship.title
        }), showScholarshipStatus && _jsx(Tag, {
          emphasis: "highlighted",
          intent: statusIntent,
          overflow: "normal",
          size: "sm",
          children: scholarship.status
        })]
      }), showSchoolGroupName && _jsx(Text, {
        contrast: "mid",
        children: scholarship.schoolGroupName
      })]
    })]
  });
};